<template>
  <div class="jianbao_box">
    <m-title></m-title>
    <div class="cont">
      <div class="changdi">
        <div class="changditop">
          <div class="changdi_left">
            <span class="name">日期</span>
            <el-date-picker v-model="starttime" type="date" class="inp" value-format="yyyy-MM-dd" placeholder="开始时间">
            </el-date-picker>
            <span class="name" style="margin-left: 0;">至</span>
            <el-date-picker v-model="endtime" type="date" class="inp" value-format="yyyy-MM-dd" placeholder="结束时间">
            </el-date-picker>
            <span class="name">类型</span>
            <div class="select_box">
              <el-select v-model="status" placeholder="请选择" clearable>
                <el-option v-for="it in statusList" :key="it.value" :value="it.value" :label="it.label"></el-option>
              </el-select>
            </div>
            <span class="name">船名</span>
            <el-input placeholder="请输入" type="text" v-model="shipname" class="inp" />
          </div>
          <div class="clear_search">
            <button class="chaxun" @click="getsearch">查询</button>
            <button class="reset" @click="reset">重置</button>
          </div>
        </div>
      </div>
      <div class="zuoyejianbao">
        <div class="echarts-title">
          <div class="left-bac"></div>
          <div class="left-name">船舶成本</div>
        </div>
        <div class="zuoyedetails">
          <div class="jb zy1" style="color: #1B6B9B;cursor: pointer;">
            <div class="cb">
              <div class="number"><span class="num">{{ shipinfo.wanchengchuanbo || 0 }}</span><span class="txts">艘</span>
              </div>
              <div class="name">完成船舶</div>
            </div>

            <!-- <img src="../../assets/homeImg/icon_figer.png" alt=""> -->
          </div>
          <div class="jb zy2" style="color: #2F419B ;">
            <div class="cb">
              <div class="number"><span class="num">{{ shipinfo.waiqiandun || 0 }}</span><span class="txts">吨</span>
              </div>
              <div class="name">外签吨</div>
            </div>
          </div>
          <div class="jb zy4" style="color: #533796;cursor: pointer;">
            <div class="cb">
              <div class="number"><span class="num">{{ shipinfo.yunshucheci || 0 }}</span><span
                  class="txts">车次</span></div>
              <div class="name">运输车次</div>
            </div>
            <!-- <img src="../../assets/homeImg/icon_figer.png" alt=""> -->
          </div>
          <div class="jb zy3" style="color:#115B76;">
            <div class="cb">
              <div class="number"><span class="num">{{ shipinfo.xiaohaodianliang || 0 }}</span><span class="txts">度</span>
              </div>
              <div class="name">消耗电量</div>
            </div>
          </div>
          <div class="jb zy5" style="color: #2F419B ;cursor: pointer;" >
            <div class="cb">
              <div class="number"><span class="num">{{ shipinfo.yunshuchengben || 0 }}</span><span class="txts">元</span>
              </div>
              <div class="name">运输成本</div>
            </div>
            <!-- <img src="../../assets/homeImg/icon_figer.png" alt=""> -->
          </div>
        </div>
      </div>
      <div class="zuoyejianbao">
        <div class="titles">
          <div class="echarts-title">
            <div class="left-bac"></div>
            <div class="left-name">单船成本</div>
          </div>
          <!-- <button class="chaxun" @click="printListPno">导出</button> -->
        </div>

        <div class="zuoyedetail">
          <el-table style="width: 100%;margin-bottom: 10px;" :data="shiplist.list" max-height="380px"
              border highlight-current-row>
            <el-table-column label="序号" type="index" width="50px" />
            <el-table-column prop="chuanming" label="船名" show-overflow-tooltip />
            <el-table-column prop="hangci" label="航次" show-overflow-tooltip />
            <el-table-column  label="到港时间" show-overflow-tooltip>
              <template v-slot="res">
                <span>{{ mydateFormat(res.row.kaogangshijian, '时分秒') }}</span>
              </template>
            </el-table-column>
            <el-table-column label="离港时间" show-overflow-tooltip>
              <template v-slot="res">
                <span>{{ mydateFormat(res.row.ligangshijian, '时分秒') }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="kaobomudi" label="装卸船" show-overflow-tooltip />
            <el-table-column prop="shijidunshu" label="货重(吨)" show-overflow-tooltip />
            <el-table-column prop="checi" label="运输车次(次)" show-overflow-tooltip />
            <!-- <el-table-column prop="dianliang" label="消耗电量(度)" show-overflow-tooltip /> -->
            <el-table-column prop="yunshuchengben" label="运输成本(元)" show-overflow-tooltip />
            <el-table-column label="操作" show-overflow-tooltip>
              <template v-slot="scoped">
                <div @click="getshipdetail(scoped.row)" style="color: #17B6A1;font-weight: 700;cursor: pointer;">
                  查看详情
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- <div class="msgstatistics">
            <span style="margin-right: 20px">计划合计:{{ shiplist.total }}条</span>
            <span>合计完成:{{ planTotal ? planTotal.workedSullte : 0 }} 吨</span>
          </div> -->
          <el-pagination :page-size="limit" layout="total,prev, pager,next, jumper" :total="shiplist.total"
            :current-page="memberlistship.page" @current-change="CurrentChangeJH" style="text-align: center;">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="单船成本" :visible.sync="dialogTable" width="90%" @close="bangdanpage = 1">
      <div class="dlg-title">
        <img class="title-left" src="../../assets/statistics/singleShipCost/pic_boat.png" alt="">
        <div class="title-right">
          <div class="right-top"><span class="name">单船成本：</span><span class="value">{{ shipCBinfo.yunshuchengben ||'0'}}(元)</span> </div>
          <div class="right-info">
            <div class="info-item"><span class="name">船名：</span><span class="value">{{ shipCBinfo.chuanming ||'-' }}</span></div>
            <div class="info-item"><span class="name">靠泊目的：</span><span class="value">{{ shipCBinfo.kaobomudi ||'-'}}</span></div>
            <div class="info-item"><span class="name">外签吨：</span><span class="value">{{ shipCBinfo.shijidunshu ||'0' }}(吨)</span></div>
            <div class="info-item"><span class="name">航次：</span><span class="value">{{shipCBinfo.hangci ||'-'}}</span></div>
            <div class="info-item"><span class="name">作业效率：</span><span class="value">{{ shipCBinfo.zuoyexiaolv||'-' }}(吨)</span></div>
            <div class="info-item"><span class="name">离港日期：</span><span class="value">{{ mydateFormat(shipCBinfo.ligangshijian,'时分秒') ||'-' }}</span></div>
            <div class="info-item"><span class="name">运输车次：</span><span class="value">{{ shipCBinfo.checi ||'0' }}(次)</span></div>
            <!-- <div class="info-item"><span class="name">消耗电量：</span><span class="value">{{ shipCBinfo.dianliang ||'0' }}(度)</span></div> -->
          </div>
        </div>
      </div>
      <div class="dlg-table">
        <div class="table-left">
          <el-table :data="pnoList" height="300">
            <el-table-column type="index" label="序号"/>
            <el-table-column prop="jihuahao" label="计划号" show-overflow-tooltip/>
            <el-table-column label="计划状态" show-overflow-tooltip>
              <template v-slot="res">
                <span>{{ getstatus(res.row.zhuangtai) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="fahuodi" label="发货地" show-overflow-tooltip />
            <el-table-column prop="fawangdi" label="发往地" show-overflow-tooltip />
            <el-table-column prop="checi" label="运输车次(次)" show-overflow-tooltip />
            <!-- <el-table-column prop="dianliang" label="消耗电量(度)" show-overflow-tooltip /> -->
            <el-table-column prop="yunshuchengben" label="计划成本(元)" show-overflow-tooltip />
          </el-table>
          <!-- <el-pagination layout="total,prev, pager,next, jumper" :page-size="limit" 
            :current-page.sync="bangdanpage" @current-change="dialogCurrentChange"></el-pagination> -->
        </div>
        <div class="table-right">
          <el-table :data="fleetList" height="300">
            <el-table-column type="index" label="序号"/>
            <el-table-column prop="chedui" label="车队" show-overflow-tooltip/>
            <el-table-column prop="checi" label="运输车次(次)" show-overflow-tooltip />
            <!-- <el-table-column prop="dianliang" label="消耗电量(度)" show-overflow-tooltip /> -->
            <el-table-column prop="yunshuchengben" label="车队成本(元)" show-overflow-tooltip />
          </el-table>
          <!-- <el-pagination layout="total,prev, pager,next, jumper" :page-size="limit" 
            :current-page.sync="bangdanpage" @current-change="dialogCurrentChange"></el-pagination> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mTitle from '@/components/mTitle.vue';
// import { printExcel } from '@/plugins/other.js';
import dayjs from "dayjs";
export default {
  data() {
    return {
      statusList: [
        { label: "装船", value: "装船" },
        { label: "卸船", value: "卸船" },
      ],
      status: null,
      shipname: null,
      starttime: null,
      endtime: dayjs().format("YYYY-MM-DD"),
      shiplist: {},
      carlist: [],
      shipCBinfo: {},
      shipinfo: {},
      memberlistship: {
        page: 1,
      },
      limit: 10,
      dialogTable: false,
      bangdanpage: 1,
      fleetList:[],
      pnoList:[]
    }
  },
  components: {
    mTitle,
  },
  mounted() {
    this.starttime=dayjs().subtract(3, 'day').format("YYYY-MM-DD")
    this.getsearch()
  },

  methods: {
    getstatus(val){
      let res
      switch (val) {
        case '0':
        res='进行中'
          break;
        case '1':
          res='已完成'
          break;
        case '2':
          res='暂停中'
          break;
        case '3':
          res='已作废'
          break;
      }
      return res
    },
    //查询
    getsearch() {
      this.getshiplist()
      // this.getCar()
      // this.getFleet()
    },
    //重置
    reset() {
      this.shipname = null
      this.starttime = null
      this.endtime = null
      this.status = null
      this.memberlistship.page = 1
      this.getsearch()
    },
    CurrentChangeJH(e) {
      this.memberlistship.page = e
      this.getshiplist()
    },
    /**
     * 单船成本页面查询
     */
    async getshiplist() {

      const { data } = await this.$http(
        "api1",
        "/replenish/DriverCarPreCost/speculateFreightShip",
        "get",
        {
          shipName: this.shipname,
          startTime: this.starttime,
          endTime: this.endtime,
          type: this.status,
          limit: this.limit,
          page: this.memberlistship.page
        }
      );
      console.log(data);
      if (data.code != 0) return this.$message.error(data.msg);
      data.danchuanchengben.list.map(item=>{
        item.shijidunshu=(item.shijidunshu*1).toLocaleString()
        item.yunshuchengben=((parseInt(item.yunshuchengben * 100) / 100).toFixed(2)*1).toLocaleString()
      })
      data.chuanbochengben.yunshuchengben=((parseInt(data.chuanbochengben.yunshuchengben * 100) / 100).toFixed(2)*1).toLocaleString()
      data.chuanbochengben.xiaohaodianliang =data.chuanbochengben.xiaohaodianliang.toLocaleString()
      data.chuanbochengben.yunshucheci =data.chuanbochengben.yunshucheci.toLocaleString()
      data.chuanbochengben.waiqiandun=data.chuanbochengben.waiqiandun.toLocaleString()
      console.log(data);
      this.shiplist = data.danchuanchengben;
      
      this.shipinfo = data.chuanbochengben
    },
    /**
     * 单船成本详情
     */
    async getshipdetail(row) {
    console.log(row.id.toString());
      this.dialogTable = true
      const { data } = await this.$http(
        "api1",
        "/replenish/DriverCarPreCost/speculateFreightOnlyShip",
        "get",
        {
          id:row.id
        }
      );
      if (data.code != 0) return this.$message.error(data.msg);
      // row.yunshuchengben=row.yunshuchengben.toLocaleString()
      this.shipCBinfo=row
      data.chedui.map(item=>{
        item.yunshuchengben=((parseInt(item.yunshuchengben * 100) / 100).toFixed(2)*1).toLocaleString()
      })
      data.jihua.map(item=>{
        item.yunshuchengben=((parseInt(item.yunshuchengben * 100) / 100).toFixed(2)*1).toLocaleString()
      })
      // data.jihua=data.jihua.filter(item=>item.jihuahao.includes('J'))
      this.fleetList=data.chedui
      this.pnoList=data.jihua
    }
  }
}
</script>

<style lang="scss" scoped>
.dlg-title {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .title-left {
    width: 45%;
  }

  .title-right {
    width: 55%;
    padding: 20px;
    box-sizing: border-box;

    .right-top {
      margin-bottom: 20px;
      font-size: 120%;
      font-weight: bold;

      .name {
        color: #333
      }

      .value {
        color: #03A590
      }
    }

    .right-info {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      row-gap: 15px;

      .info-item {
        font-size: 80%;

        .name {
          color: #333;
          font-weight: bold;
        }

        .value {
          color: #656565
        }
      }
    }
  }
}

.dlg-table {
  display: flex;
  justify-content: space-between;

  .table-left {
    width: 55%;
  }

  .table-right {
    width: 40%;
  }
}

.el-table .warning-row {
  background: oldlace;
}

.jianbao_box {

  width: 100%;
  height: 100%;

  .cont {
    position: relative;
    width: 100%;
    height: calc(100% - 50px);
    overflow: auto;
    background-color: #f5f6fa;
    padding: 10px;
    box-sizing: border-box;

    .changdi {
      width: 100%;
      background-color: #fff;
      margin: 10px 0;
      padding: 20px;
      box-sizing: border-box;
      border-radius: 8px;

      .changditop {

        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        .changdi_left {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .inp {
            width: 150px;
            height: 30px;
          }

          .name {
            font-size: 14px;
            margin: 0 10px;
          }

          .select_box {
            display: inline-block;
            font-weight: 400;
            width: 120px;
            height: 30px;
            vertical-align: middle;
            margin-left: 10px;
            background: #f3f4f5;
            line-height: 30px;
          }

        }

        .clear_search {
          .chaxun {
            width: 80px;
            height: 30px;
            background: #17B6A1;
            border-radius: 8px;
            color: #fff;
            line-height: 30px;
            text-align: center;
            border: none;
            font-size: 80%;
          }

          .reset {
            width: 80px;
            height: 30px;
            background-color: #F5F6FA;
            border-radius: 8px;
            color: #17B6A1;
            line-height: 30px;
            text-align: center;
            border: none;
            font-size: 80%;
            margin-left: 19px;
          }
        }
      }
    }
    .zuoyejianbao {
      width: 100%;
      background: #FFFFFF;
      border-radius: 8px;
      margin-top: 20px;
      padding: 0 34px;
      box-sizing: border-box;

      .echarts-title {
        padding: 10px 0;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .left-bac {
          width: 12px;
          height: 26px;
          background: #17B6A1;
          border-radius: 6px;
          margin-right: 11px;
        }

        .left-name {
          font-size: 100%;
          font-family: PingFang SC;
          font-weight: 600;
          color: #2D3748;
        }
      }

      .titles {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .echarts-title {
          padding: 10px 0;
          box-sizing: border-box;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .left-bac {
            width: 12px;
            height: 26px;
            background: #17B6A1;
            border-radius: 6px;
            margin-right: 11px;
          }

          .left-name {
            font-size: 100%;
            font-family: PingFang SC;
            font-weight: 600;
            color: #2D3748;
          }
        }

        .chaxun {
          width: 80px;
          height: 30px;
          background: #17B6A1;
          border-radius: 8px;
          color: #fff;
          line-height: 30px;
          text-align: center;
          border: none;
          font-size: 80%;
        }
      }


      .zuoyedetail {
        padding-bottom: 10px;

        .msgstatistics {

          font-size: 80%;
          line-height: 35px;
          text-align: center;
          color: #fff;
          font-weight: bold;
          background: #17B6A1;
        }
      }

      .zuoyedetails {
        padding-bottom: 10px;
        display: flex;
        justify-content: space-evenly;

        .jb {
          width: 19%;
          // height: 150px;
          aspect-ratio: 20/9;
          position: relative;
          font-size: 20px;

          .cb {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            padding-left: 30%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }

          .number {
            margin-bottom: 15px;

            .num {
              font-size: 100%;
              font-weight: 600;
            }

            .txts {
              font-size: 60%;
            }
          }

          .name {
            font-size: 60%;
          }

          img {
            width: 20px;
            height: 30px;
            position: absolute;
            right: 15px;
            bottom: 15px;
          }
        }

        @for $i from 1 through 5 {
          .zy#{$i} {
            background-image: url(../../assets/statistics/singleShipCost/pic#{$i}.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;

          }
        }

      }
    }
  }

}
</style>